import StorageService from "../services/storage-service"
import {useEffect} from "react"
import {JWT_STORAGE_KEY} from "./constants"
import AuthService from "../services/auth-service"

const RefreshToken = () => {
    const storageService = new StorageService()
    const authService = new AuthService()

    useEffect(() => {
        verifyTokenExp()
    }, [])

    const getExpirationToken = () => {
        const token = storageService.getItemLocalStorage(JWT_STORAGE_KEY).split(".")[1]
        if (!token) return null

        const payload = JSON.parse(atob(token))
        return payload.exp || null
    }

    const verifyTokenExp = async () => {
        const tokenExpDate = getExpirationToken()

        const now = Math.floor(Date.now() / 1000)
        const secondsUntilExpiration = tokenExpDate - now

        if (secondsUntilExpiration < 1800) { // se estiver faltando 30 min para expirar o token
            await authService.refreshToken()
        }
    }

}

export default RefreshToken